import React from 'react';
import { useTranslation } from 'react-i18next';
import RegisterForm from './components/Login/RegisterForm';
import { ROUTES } from './routes';
import SEO from './components/shared/SEO';

const Register = () => {
    const { t } = useTranslation();

    return (
        <div className="min-h-screen bg-panel-gray flex items-center justify-center p-4">
            <SEO title={t('MetaRegister.title')} description={t('MetaRegister.description')} />
            {/* Background decoration */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute top-0 right-0 w-96 h-96 bg-primary-green opacity-5 rounded-full blur-3xl"></div>
                <div className="absolute bottom-0 left-0 w-96 h-96 bg-secondary-blue opacity-5 rounded-full blur-3xl"></div>
            </div>

            {/* Register Form Container */}
            <div className="relative z-10 w-full">
                <RegisterForm />

                {/* Back to main link */}
                <div className="text-center mt-6">
                    <a
                        href={ROUTES.MAIN}
                        className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-800 font-semibold transition-colors"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-5 h-5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
                        </svg>
                        {t('Register.link_back_main')}
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Register;
// Revisado: 2026-02-21 [I18n Scan] - [Meta SEO]
